export enum ControlConfigDirection {
    ROW = 0,
    COLUMN = 1
}

export interface IControlConfigArgs {
    showLabel?: boolean;
    direction?: ControlConfigDirection;
    includeInJobCard?: boolean;
    excludeFromSummary?: boolean;
}

const defaults = () => ({
    showLabel: true,
    direction: ControlConfigDirection.ROW,
    includeInJobCard: false,
    excludeFromSummary: false
});

/**
 * NOTE TO DEVELOPER:
 * If you add extra properties to this class you should consider also updating ControlHelper and form-manager-control-form-page.html to
 * all the users to edit the value for all controls.
 */
export class ControlConfig {

    showLabel: boolean;
    direction: ControlConfigDirection;
    includeInJobCard: boolean;
    excludeFromSummary: boolean;

    constructor(data?: IControlConfigArgs) {

        data = {...defaults(), ...data};

        Object.keys(data).forEach(key => {
            this[key] = data[key];
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control/control-config.model.ts